<template>
  <div>
    <div class="bg-tonal rounded-lg text-dark px-3 py-2 mb-5">
      <div class="flex text-dark text-sm">
        <span class="font-medium">报名截止时间:</span>
        <span class="ml-2 flex-1">{{ selectedStock.end_time }}</span>
      </div>
      <div class="flex text-dark text-sm mt-1">
        <span class="font-medium">付款规则:</span
        ><span class="flex-1 ml-2">{{ selectedStock.installment_label }}</span>
      </div>
    </div>
    <el-form label-width="5em" @submit.native.prevent="onSubmit">
      <el-form-item label="出发城市">
        <el-select
          :value="selectedCityId"
          @input="$emit('update:selectedCityId', $event)"
        >
          <el-option
            v-for="city in citys"
            :key="city.city_id"
            :label="city.city_name"
            :value="city.city_id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="出发日期">
        <el-select :value="selectedStock.date" @input="onDateChange">
          <el-option
            v-for="date in dates"
            :key="date.date"
            :value="date.date"
            :label="date.date"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="选择套餐">
        <ul class="checker-group">
          <li
            v-for="meal in meals"
            :key="meal.id"
            class="checker-item"
            :class="{
              'is-selected': meal.id === selectedMealId,
            }"
            @click="$emit('update:selectedMealId', meal.id)"
          >
            <span>{{ meal.name }}</span>
            <div class="checker-item__tag">
              <i class="el-icon-check icon"></i>
            </div>
          </li>
        </ul>
      </el-form-item>
      <el-form-item label="出游人数" size="small">
        <div class="tourists flex flex-wrap">
          <div
            v-for="price in formData.prices"
            :key="price.id"
            class="tourist mr-5"
          >
            <div class="tourist-label">{{ price.name }}</div>
            <div class="tourist-input">
              <el-input-number
                :value="price.num"
                :min="price.type == 1 ? 1 : 0"
                class="w-22 block"
                size="mini"
                @input="onInputPrice(price, $event)"
              ></el-input-number>
            </div>
          </div>
          <div v-if="formData.diff_room.th_price" class="tourist mr-5">
            <div class="tourist-label">{{ formData.diff_room.name }}</div>
            <div class="tourist-input">
              <el-input-number
                v-model="formData.diff_room.num"
                :min="0"
                class="w-22 block"
                size="mini"
              />
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item v-if="formData.sub_prices.length" label="附加选项">
        <div class="additional">
          <div
            v-for="price in formData.sub_prices"
            :key="price.id"
            class="additional__item table-row"
          >
            <span class="table-cell">{{ price.name }}</span>
            <div class="table-cell">
              <el-input-number
                :value="price.num"
                :min="0"
                class="w-22 ml-8"
                size="mini"
                @input="onInputSub(price, $event)"
              />
            </div>
          </div>
        </div>
      </el-form-item>
      <!-- <el-form-item label="合计金额">
      <div class="flex items-center">
        <div class="price text-primary font-medium">
          <span class="price-unit">￥</span>
          <span class="price-num text-3xl">{{ totalAmount }}</span>
        </div>
        <el-popover title="价格明细" width="376" placement="right" :disabled="!priceTable.length">
          <el-button slot="reference" class="ml-3" type="text" size="small">查看明细</el-button>
          <div class="table">
            <div class="table-header-group">
              <div class="table-row">
                <div class="table-cell py-1">价格类型</div>
                <div class="table-cell py-1">零售价</div>
                <div class="table-cell py-1">同行价</div>
                <div class="table-cell py-1">数量</div>
              </div>
            </div>
            <div class="table-row-group text-dark">
              <ul v-for="price in priceTable" :key="price.id" class="table-row">
                <li class="table-cell py-0.5">{{ price.name }}</li>
                <li class="table-cell py-0.5">{{ price.sale_price }}</li>
                <li class="table-cell py-0.5">{{ price.th_price }}</li>
                <li class="table-cell py-0.5">{{ price.num }}</li>
              </ul>
            </div>
          </div>
        </el-popover>
      </div>
    </el-form-item> -->
      <!-- <el-form-item>
      <div class="bg-warn bg-opacity-12 rounded-md">
        <el-button class="rounded-md" :class="[!totalAmount ? '!bg-[#B2B2BD] !border-[#B2B2BD]' : '']" type="primary" native-type="submit" :disabled="!totalAmount">提交预订</el-button>
        <span class="ml-7 text-warn font-medium">利润:¥{{ totalProfit }}</span>
      </div>
    </el-form-item> -->
    </el-form>
  </div>
</template>
<script>
import { floatAdd, floatMul, floatSub, isEmpty } from "@/utils/helpers";
import { computed, ref, watch, nextTick, defineComponent } from "@nuxtjs/composition-api";
// import useRequest from "@/composables/useRequest";

import * as OrderService from "@/services/order";
import { REQUEST_CODES } from "@/constants/const-http";

export default defineComponent({
  name: "VacationDetailBookingForm",
  props: {
    citys: Array,
    selectedStock: Object,
    selectedCityId: String,
    selectedMealId: String,
    productNo: String,
    dates: {
      type: Array,
      default: () => [],
    },
    priceInfo: Object,
    meals: Array,
  },
  setup(props, context) {
    const formData = ref({
      departure_id: "",
      date: "",
      set_meal_id: "",
      prices: [],
      diff_room: {},
      sub_prices: [],
    });

    function onDateChange(date) {
      let stock = props.dates.find((stock) => stock.date === date);
      context.emit("update:selectedStock", stock);
      nextTick(() => {
        context.emit("selected-stock-change", stock);
      });
    }

    watch(
      () => props.priceInfo,
      () => {
        if (isEmpty(props.priceInfo)) {
          return;
        }
        formData.value.prices = props.priceInfo.prices.map((price) => ({
          ...price,
          num: price.type == 1 ? 2 : 0,
        }));
        formData.value.diff_room = { ...props.priceInfo.diff_room, num: 0 };
        formData.value.sub_prices = props.priceInfo.sub_prices.map((price) => ({
          ...price,
          num: 0,
        }));
      },
      {
        immediate: true,
      }
    );

    const priceTable = computed(() => {
      return [
        ...formData.value.prices,
        ...formData.value.sub_prices,
        formData.value.diff_room,
      ].filter((price) => price.num > 0);
    });

    return {
      formData,
      priceTable,
      // meals,
      // priceInfo,
      // getPrices,
      onDateChange,
    };
  },

  computed: {
    totalAmount() {
      let { prices, sub_prices, diff_room } = this.formData;
      return [...prices, ...sub_prices, diff_room].reduce(
        (sum, price) =>
          floatAdd(sum, floatMul(price.th_price || 0, price.num || 0)),
        0
      );
    },
    totalSaleAmount() {
      let { prices, sub_prices, diff_room } = this.formData;
      return [...prices, ...sub_prices, diff_room].reduce(
        (sum, price) =>
          floatAdd(sum, floatMul(price.sale_price || 0, price.num || 0)),
        0
      );
    },
    totalProfit() {
      return floatSub(this.totalSaleAmount, this.totalAmount);
    },
    // 映射 右侧所需的数据
    priceData() {
      const { totalProfit, totalAmount, priceTable } = this;

      return {
        totalProfit,
        totalAmount,
        priceTable,
      };
    },
  },

  methods: {
    onInputDiffRoom(num) {
      this.priceInfo.diff_room = Object.assign(this.priceInfo.diff_room, {
        num: num || 0,
      });
    },
    onInputPrice(price, num) {
      let index = this.formData.prices.findIndex(
        (item) => item.id === price.id
      );
      this.formData.prices.splice(index, 1, {
        ...this.formData.prices[index],
        num,
      });
    },
    onInputSub(price, num) {
      let index = this.formData.sub_prices.findIndex(
        (item) => item.id === price.id
      );
      this.formData.sub_prices.splice(index, 1, {
        ...this.formData.sub_prices[index],
        num,
      });
    },
    async onSubmit() {
      try {
        let { code, data, msg } = await OrderService.submitLineOrderBooking({
          product_no: this.productNo,
          date_id: this.selectedStock.vpd_id,
          departure_id: this.selectedCityId,
          set_meal_id: this.selectedMealId,
          price_type: this.priceInfo.price_type,
          prices: this.formData.prices.map(({ id, num }) => ({
            id,
            num,
          })),
          sub_prices: this.formData.sub_prices.map(({ id, num }) => ({
            id,
            num,
          })),
          diff_room: this.formData.diff_room.num || 0,
        });
        if (code !== REQUEST_CODES.ERROR_OK) {
          this.$message.error(msg);
          return;
        }
        this.$router.push({
          name: "product-vacation-placeholder",
          query: data,
        });
      } catch (error) {
        console.error(error);
      }
    },
  },
  watch: {
    priceData: {
      handler: function (value) {
        this.$emit("input", value);
      },
      deep: true,
    },
  },
});
</script>
<style lang="scss" scoped>
.checker-group {
  display: flex;
}
.checker-item {
  border-radius: 0.5rem;
  cursor: pointer;
  line-height: 1.25rem;
  overflow: hidden;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-transition-property: background-color, border-color, color, fill, stroke;
  -o-transition-property: background-color, border-color, color, fill, stroke;
  transition-property: background-color, border-color, color, fill, stroke;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  border: $border-base;
}
.checker-item + .checker-item {
  margin-left: 0.5rem;
}
.checker-item.is-selected {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 94, 220, var(--tw-bg-opacity));
  --tw-bg-opacity: 0.1;
  --tw-border-opacity: 1;
  border-color: rgba(0, 94, 220, var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
.checker-item.is-selected .checker-item__tag {
  opacity: 1;
}
.checker-item__tag {
  height: 0.75rem;
  font-size: 0.75rem;
  line-height: 1rem;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  right: 0px;
  bottom: 0px;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  width: 0.75rem;
  z-index: 1;
  -webkit-transition-property: opacity;
  -o-transition-property: opacity;
  transition-property: opacity;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
}
.checker-item__tag .icon {
  font-weight: 500;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-translate-z: 0;
  --tw-rotate: 0;
  --tw-rotate-x: 0;
  --tw-rotate-y: 0;
  --tw-rotate-z: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-scale-z: 1;
  -webkit-transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z)) rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z));
  -ms-transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z)) rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z));
  transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z)) rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z));
  --tw-scale-x: 0.8;
  --tw-scale-y: 0.8;
  --tw-scale-z: 0.8;
}
.checker-item__tag::after {
  content: "";
  width: 200%;
  height: 200%;
  border-radius: 50%;
  left: 0;
  bottom: -100%;
  --tw-bg-opacity: 1;
  background-color: rgba(0, 94, 220, var(--tw-bg-opacity));
  position: absolute;
  z-index: -1;
}
</style>
